import useCurrentWalletConnectionState from 'src/hooks/useCurrentWalletConnectionState';
import { WalletToDisplayInfo } from 'src/hooks/useWalletsToDisplay';
import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';
import { cj } from 'src/utils/classNames';
import ConnectWalletModalButton from 'src/components/Modals/Onboarding/ConnectWalletModal/ConnectWalletModalButton';

export const WALLET_BUTTON_ICON_CLASSNAME = 'size-4';

export const WALLET_PROVIDER_BG_CLASSNAME: Record<string, string> = {
	MathWallet: 'bg-[#000]',
};

export const walletsToAddPaddingFor = ['MathWallet', 'WalletConnect'];

export const WalletButton = (props: {
	wallet: WalletToDisplayInfo;
	onChooseWallet?: (selection: string) => void;
	hideDetectedLabel?: boolean;
}) => {
	const currentlySelectedWallet = useVelocityStore((s) => s.wallet.current);
	const walletConnectionState = useCurrentWalletConnectionState();
	const walletProvider = props.wallet.provider;

	const isConnecting =
		walletConnectionState.instance.is('Connecting') &&
		currentlySelectedWallet.adapter?.name === walletProvider.adapter.name;

	const walletProviderBgClassName = (() => {
		const { name } = walletProvider.adapter;
		if (!(name in WALLET_PROVIDER_BG_CLASSNAME)) {
			return;
		}

		return WALLET_PROVIDER_BG_CLASSNAME[name];
	})();

	return (
		<ConnectWalletModalButton
			onClick={() => props.onChooseWallet?.(walletProvider.adapter.name ?? '')}
			key={walletProvider.adapter.name}
			dataTestId={`connect-wallet-button-${walletProvider.adapter.name}`}
			isLoading={isConnecting}
		>
			{!isConnecting && (
				<div
					className={cj(
						WALLET_BUTTON_ICON_CLASSNAME,
						walletsToAddPaddingFor.includes(walletProvider.adapter.name) &&
							'p-xs',
						walletProviderBgClassName
					)}
				>
					<img src={walletProvider.adapter.icon} alt="" className="size-full" />
				</div>
			)}

			<span className="text-left">{walletProvider.adapter.name}</span>
		</ConnectWalletModalButton>
	);
};
